import { Component, OnDestroy, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

declare global {
	interface Window {
		$crisp: any;
	}
}

const CRISP_CHAT_STATE_KEY = 'crisp_chat_open';

@Component({
	selector: 'ph-crisp-button',
	templateUrl: './ph-crisp-button.component.html',
	styleUrls: ['./ph-crisp-button.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [PhIconWrapperComponent, PhIconComponent],
	standalone: true
})
export class PhCrispButtonComponent implements OnDestroy {

	public isCrispChatOpen: WritableSignal<boolean> = signal<boolean>(false);
    public isExist: WritableSignal<boolean> = signal<boolean>(false);
    
	private listenersRegistered: boolean = false;
	private readonly handleChatOpened = (): void => this.setChatState(true);
	private readonly handleChatClosed = (): void => this.setChatState(false);

	ngOnInit(): void {
        if (!window.CRISP_WEBSITE_ID) return;
        this.isExist.set(true);
		const storedValue: string = localStorage.getItem(CRISP_CHAT_STATE_KEY);
		this.isCrispChatOpen.set(storedValue === 'true');
		this.registerCrispListeners();
	}

	public toggleCrispChat(): void {
		if (!window.$crisp) return;
		
		const newState: boolean = !this.isCrispChatOpen();
		this.setChatState(newState);
		
		if (newState) {
			window.$crisp.push(['do', 'chat:open']);
		} else {
			window.$crisp.push(['do', 'chat:close']);
		}
	}

	public ngOnDestroy(): void {
		if (!window.$crisp || !this.listenersRegistered) return;

		window.$crisp.push(['off', 'chat:opened', this.handleChatOpened]);
		window.$crisp.push(['off', 'chat:closed', this.handleChatClosed]);
		this.listenersRegistered = false;
	}

	private registerCrispListeners(): void {
		if (this.listenersRegistered) return;
		if (!window.$crisp) {
			(window as any).$crisp = [];
		}

		window.$crisp.push(['on', 'chat:opened', this.handleChatOpened]);
		window.$crisp.push(['on', 'chat:closed', this.handleChatClosed]);
		this.listenersRegistered = true;
	}

	private setChatState(isOpen: boolean): void {
		this.isCrispChatOpen.set(isOpen);
		localStorage.setItem(CRISP_CHAT_STATE_KEY, String(isOpen));
	}
}

